import React from 'react';
import { useParams } from 'react-router-dom';

/**
 * @typedef {object} RouteParamReloaderProps
 * @property {React.ComponentType<*>} component
 */

/**
 * @param {RouteParamReloaderProps} props
 */
const RouteParamReloader = props => {
  const { component: Component } = props;

  const params = useParams();
  const paramKey = Object.values(params).join('-');

  const ReloaderComponent = Component;
  return <ReloaderComponent key={paramKey} />;
};

export default RouteParamReloader;
